/**
 * Label Mapping Configuration
 *
 * Change the values below to remap all UI labels across the application.
 * For example, to revert to original labels, set Brand: "Brand" and Product: "Product".
 * All UI labels will automatically reflect the change.
 *
 * NOTE: This only affects UI display labels. It does NOT change
 * API parameters, data keys, variable names, or any backend dependencies.
 */

export const ENTITY_LABELS = {
  Brand: "Institution",
  Product: "Program",
  PurchaseCriteria: "Applicant Criteria",
};

/**
 * Replaces "Brand" and "Product" (as whole words) in a label string
 * with their mapped values from ENTITY_LABELS.
 * @param {string} label - The original label text
 * @returns {string} - The mapped label text
 */
export function mapLabel(label) {
  if (!label) return label;
  return label
    .replace(/\bBrand\b/g, ENTITY_LABELS.Brand)
    .replace(/\bProduct\b/g, ENTITY_LABELS.Product);
}

/**
 * Returns the mapped label for a discovery type value ("brand" or "product").
 * @param {string} type - "brand" or "product"
 * @returns {string} - The mapped display label
 */
export function getEntityLabel(type) {
  if (type === "brand") return ENTITY_LABELS.Brand;
  if (type === "product") return ENTITY_LABELS.Product;
  return type;
}
